import type { FunctionComponent } from 'react';

import { icons, IconText } from '../../../generic';
import Button from '../../../generic/Button';
import Text from '../../../generic/Text';

import JiraSettingsHeader from './JiraSettingsHeader';

type JiraSettingsEmptyProps = {
  onClickAddSite: () => void;
};

/**
 * Empty state for if the org hasn't setup any Jiras yet.
 */
const JiraSettingsEmpty: FunctionComponent<JiraSettingsEmptyProps> = ({ onClickAddSite }) => (
  <div className="jira-settings__empty">
    <JiraSettingsHeader
      subheading="Export FOSSA issues to your Jira instance to streamline tracking and communication. Automatically resolve FOSSA issues when the Jira issue is closed. You can find more detailed setup instructions in the documentation."
    />
    <Text.H3>
      Requirements
    </Text.H3>
    <ul className="jira-settings__empty__requirements">
      <li>Jira site URL</li>
      <li>Username and API key (which grants FOSSA access to your Jira instance)</li>
    </ul>
    <Button
      type="primary"
      size="large"
      onClick={onClickAddSite}
    >
      <IconText
        icon={icons.plus}
        text="Add Site"
      />
    </Button>
  </div>
);

export default JiraSettingsEmpty;
